import { Component, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { TemplateUploadModalComponent } from '../template-upload-modal/template-upload-modal.component';
import { TemplatesService } from '../templates/templates.service';
import * as XLSX from 'xlsx';
import { FormControl } from '@angular/forms';
import { QuestionModel } from 'src/app/Models/QuestionModel';
import { AddProposalService } from '../proposals/add-proposal/add-proposal.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProposalRepositoryService } from '../proposal-repository/proposal-repository.service';
import { forEach } from 'jszip';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-question-scanning',
  templateUrl: './question-scanning.component.html',
  styleUrls: ['./question-scanning.component.css']
})
export class QuestionScanningComponent {
  @ViewChild('fileInputRef') fileInputRef: ElementRef;
  fileUploadForm: FormGroup;
  isFileInputFormDisabled = false;
  // fileInput: File | null = null;
  questionsData: any[] = [];
  customerNames: string[] = [];
  isDropdownDisabled: boolean = true;
  public domains: any = [];
  recentItems: any;
  public searchText: string = '';
  public size: number = 9;
  public from: number = 0;
  editingIndex: number | null = null;
  domainControl = new FormControl();
  selectedValue: string;
  domainValue: string;
  newQuestion = { name: '', description: '' };

  // In your component class
  proposals: string[] = ['Proposal 1', 'Proposal 2', 'Proposal 3', ' Other ']; // Example options, replace with your actual data
  proposalValue: string; // Variable to store the selected proposal
  //otherProposal: string = '';
  otherProposalValue: string = '';


  isFileInputDisabled: boolean = true;

  editedQuestion = { name: '', description: '' };
  addMode = false;
  addModeIndex: number | null = null; // Track the index where Add button was clicked



  constructor(private router: Router, public dialogRef: MatDialogRef<TemplateUploadModalComponent>,
    public dialog: MatDialog, private _templatesService: TemplatesService,
    private _proposalService: AddProposalService, private formBuilder: FormBuilder, private service: ProposalRepositoryService, private toaster: ToastrService
  ) {
    this.fileUploadForm = this.formBuilder.group({
      fileType: ['', Validators.required],
      domain: ['', Validators.required],
      proposal: ['', Validators.required],
      otherProposal: ['', Validators.required],
      fileInput: ['', Validators.required]
    });
  }


  ngOnInit() {
    this.getDomains();
    this.getData();
  }


  getData() {
    this.service.getProposalData(null, this.searchText, this.from, this.size).subscribe(x => {
      this.recentItems = x.data.proposals;
      this.recentItems.forEach(item => {
        this.customerNames.push(item.customerName);
      });
      this.customerNames.push('Other');
    }
    );


  }





  calculateTextareaHeight(text: string): string {
    const lineHeight = 18; // Adjust this value based on your font size and line height
    const lines = text.split('\n').length; // Count the number of lines in the text
    const minHeight = lineHeight * 2; // Minimum height for two lines of text

    // Calculate the height based on the number of lines
    const calculatedHeight = Math.max(minHeight, lines * lineHeight) + 'px';
    return calculatedHeight;
  }


  calculateTextareaRows(text: string): number {
    const lineHeight = 18; // Adjust this value based on your font size and line height
    const maxHeight = 200; // Maximum height for the textarea in pixels

    // Calculate the number of rows based on content and maximum height
    const calculatedRows = Math.min(Math.ceil(text.length / 40), Math.floor(maxHeight / lineHeight));
    return calculatedRows > 0 ? calculatedRows : 1;
  }



  onSelected() {
    this.updateFileInputStatus();
  }

  domainChange() {
    this.updateFileInputStatus();

  }

  // Method to handle changes in the proposal dropdown
  proposalChange() {
    this.otherProposalValue = ''
    if (this.proposalValue === 'Other') {
      // Reset the proposalValue to empty when "Other" is selected
      //this.proposalValue = '';
    }

    this.updateFileInputStatus();
  }


  private updateFileInputStatus() {
    const hasSelectedValue = !!this.selectedValue;
    const hasDomainValue = !!this.domainValue;
    const hasProposalValue = !!this.proposalValue;
    const hasOtherProposalValue = !!this.otherProposalValue;

    if (hasSelectedValue && hasDomainValue && (hasProposalValue && this.proposalValue !== 'Other' || (this.proposalValue === 'Other' && hasOtherProposalValue))) {
      this.isFileInputDisabled = false;
    } else {
      this.isFileInputDisabled = true;
    }
  }


  isSaveButtonEnabled(): boolean {
    // Check if all required fields are selected or filled
    return !this.isFileInputDisabled && this.questionsData.length > 0;
  }







  handleFileInput(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      this.fileUploadForm.controls['fileInput'].setValue(file); // Set the value of the file input control
      this.readQuestionsFromFile(file);
    }
  }


  public getHeight(element: HTMLElement): string {
    return element.scrollHeight + 'px';
  }

  readQuestionsFromFile(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Assuming 'A' is the column for Question Name and 'B' for Question Description
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      const questionsData: { name: string, description: string }[] = [];

      for (let rowNum = range.s.r + 1; rowNum <= range.e.r; rowNum++) {
        const questionNameCell = worksheet[XLSX.utils.encode_cell({ r: rowNum, c: 0 })];
        const questionDescriptionCell = worksheet[XLSX.utils.encode_cell({ r: rowNum, c: 1 })];

        if (questionNameCell && questionDescriptionCell) {
          const questionName = questionNameCell.v as string;
          const questionDescription = questionDescriptionCell.v as string;

          questionsData.push({ name: questionName, description: questionDescription });
        }
      }

      this.questionsData = questionsData;
    };
    reader.readAsArrayBuffer(file);
  }




  deleteQuestion(index: number) {
    this.questionsData.splice(index, 1);
  }



  editQuestion(index: number) {
    this.editingIndex = index;
    // Copy the current question data to editedQuestion for editing
    this.editedQuestion = { ...this.questionsData[index] };
  }




  saveEdit(index: number) {
    if (this.editingIndex !== null) {
      this.questionsData[this.editingIndex] = { ...this.editedQuestion };
      this.cancelEdit();
    }
  }

  cancelEdit() {
    this.editingIndex = null;
    this.editedQuestion = { name: '', description: '' }; // Reset editedQuestion
  }



  toggleAddMode() {

    this.addModeIndex = 10;
  }

  saveNewQuestion() {
    if (this.newQuestion.name.trim() !== '') {
      this.questionsData.push({ name: this.newQuestion.name });
      this.newQuestion.name = '';
      this.addModeIndex = null;
    }
  }

  cancelAdd() {
    this.newQuestion = { name: '', description: '' };
    this.addModeIndex = null;
  }




  getDomains(): Promise<any[]> {
    this.domains = [];
    return new Promise<any[]>((resolve, reject) => {
      this._proposalService.getDomains().subscribe(x => {
        let y = x.data.items.map(item => item.name);
        this.domains = y;
        resolve(this.domains)
      });
    });
  }





  cancel() {
    this.dialogRef.close();
  }



  SaveData() {
    if (this.questionsData.length > 0) {

      var questionsAdd = new QuestionModel();
      questionsAdd.questionType = this.selectedValue;
      questionsAdd.domainType = this.domainValue;
      questionsAdd.proposal = this.otherProposalValue !== '' ? this.otherProposalValue : this.proposalValue;
      questionsAdd.questionsList = this.questionsData;
      var dataResult = this._templatesService.AddQuestions(questionsAdd)
        .subscribe(res => {
          this.toaster.success("Details Saved Successfully");
          // Reset form after saving data
          this.fileUploadForm.reset();
          const fileInput = document.getElementById('fileInput') as HTMLInputElement;
          fileInput.value = '';
          //  fileInputElement.value = ''; // Manually reset the file input element
          //this.resetFileInput();
          this.selectedValue = undefined;
          this.domainValue = undefined;
          this.proposalValue = undefined;
          this.otherProposalValue = '';
          this.questionsData = [];
          this.newQuestion = { name: '', description: '' };
          this.editedQuestion = { name: '', description: '' };
          this.editingIndex = null;
          this.addModeIndex = null;
        });
    }



  }

  resetFileInput(): void {
    if (this.fileUploadForm.valid) {
      // Perform the form submission logic
      this.fileInputRef.nativeElement.value = ''; // Clear the file input value
    }
  }





}



